export default __webpack_public_path__ + "static/media/Logos_Aurea2.a0e39b81.png";